@if (billingAddress && isOpen) {
    <div class="p-36:t">
        <app-logged-in-user-detail label="Addresse">
            @if (isCompany) {
                {{ billingAddress.company }}<br />
                {{ billingAddress.street }}<br />
                {{ billingAddress.zip }}&nbsp;{{ billingAddress.city }}
            } @else {
                {{ billingAddress.title.description }}
                {{ billingAddress.firstName }}
                {{ billingAddress.lastName }}
                <br />
                {{ billingAddress.street }}<br />
                {{ billingAddress.zip }}&nbsp;{{ billingAddress.city }}
            }
        </app-logged-in-user-detail>
        <app-logged-in-user-detail label="Ansprechpartner">
            {{ billingAddress.firstName }} {{ billingAddress.lastName }}
        </app-logged-in-user-detail>
        <app-logged-in-user-detail label="Telefon">
            {{ billingAddress.phone }}
        </app-logged-in-user-detail>
        <app-logged-in-user-detail label="E-Mail">
            {{ billingAddress.mail }}
        </app-logged-in-user-detail>
        <app-logged-in-user-detail label="Geburtsdatum">
            {{ billingAddress.dateOfBirth }}
        </app-logged-in-user-detail>
        <app-navigation-buttons
            [nextDisabled]="!billingAddress"
            [showBack]="isFirstStep"
            (prev)="btnPrev()"
            (next)="submit()"
        ></app-navigation-buttons>
    </div>
}
